import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getAdminApplyApi, putAdminApplyApi } from '../../service';
import { Alert, Button, Drawer, message, Modal, Spin } from 'antd';
import classNames from 'classnames';
import moment from 'moment';
import { useEffect } from 'react';
import { useDrawer } from './hooks/useDrawer';
import { createUseStyles } from 'react-jss';
// css
const useStyles = createUseStyles({
    stepsWrap: {
        marginLeft: '30px',
        position: 'relative',
    },
    leftLine: {
        position: 'absolute',
        top: '18px',
        transform: 'translateX(5px)',
        height: 'calc(100% - 70px)',
        width: '1px',
        backgroundColor: 'var( --lj-primary-color )',
        '&.grey': {
            backgroundColor: '#aaa',
        },
    },
    steps: {
        height: '60px',
        display: 'flex',
        justifyContent: 'space-between',
    },
    left: {
        minWidth: '12px',
        width: '12px',
        height: '12px',
        borderRadius: '50%',
        border: '2px solid var( --lj-primary-color )',
        transform: 'translateY(50%)',
        '&.grey': {
            borderColor: '#aaa',
        },
    },
    staff: {
        height: '45px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    info: {
        height: '45px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    center: {
        flex: 1,
        marginLeft: '10px',
        minWidth: '100px',
        '& .staff1': {
            fontWeight: 'bold',
            '&.grey': {
                color: '#aaa',
            },
        },
    },
    right: {
        textAlign: 'right',
        '& .rightInfo': {
            color: '#aaa',
            '& .msg': {
                textAlign: 'left',
            },
        },
    },
    tipAlert: {
        '& .ant-alert-icon': {
            alignSelf: 'flex-start',
            marginTop: '5px',
        },
    },
});
const SenderDraw = ({ id, visible, onVisibleChange, onLoaded, }) => {
    const { spinning, setSpinning, dataInfo, setDataInfo, stateMap } = useDrawer();
    // css
    const styles = useStyles();
    const getAdminApply = () => {
        setSpinning(true);
        getAdminApplyApi(id)
            .then((res) => {
            setSpinning(false);
            if (res.code === 200) {
                setDataInfo(res.data ?? {});
            }
        })
            .catch(() => setSpinning(false));
    };
    const revoke = () => {
        Modal.confirm({
            content: `确认撤销更换【${dataInfo.changeEmployeeName}】成为企业管理员`,
            title: '确认撤销',
            closable: false,
            onOk: () => {
                // 撤销的状态是3
                putAdminApplyApi({
                    ...dataInfo,
                    id: id,
                    verifyStatus: 3,
                }).then((res) => {
                    if (res.code === 200) {
                        message.success('已撤销');
                        getAdminApply();
                        onLoaded?.();
                    }
                });
            },
        });
    };
    useEffect(() => {
        if (visible) {
            getAdminApply();
        }
    }, [visible]);
    return (_jsx(Drawer, { title: "\u66F4\u6362\u7BA1\u7406\u5458", width: 500, visible: visible, onClose: () => onVisibleChange(false), footer: dataInfo.verifyStatus === 0 ? (_jsx("div", { style: { textAlign: 'right' }, children: _jsx(Button, { type: "primary", onClick: revoke, children: "\u64A4\u9500" }) })) : (false), children: _jsxs(Spin, { spinning: spinning, children: [_jsx(Alert, { type: stateMap(dataInfo.verifyStatus)?.alertType, className: styles.tipAlert, message: _jsxs(_Fragment, { children: [_jsx("div", { style: { fontWeight: 'bolder' }, children: "\u66F4\u6362\u4F01\u4E1A\u7BA1\u7406\u5458" }), _jsxs("div", { style: { color: '#444', marginTop: '6px' }, children: [dataInfo.verifyStatus === 0 && (_jsxs("span", { children: ["\u3010", dataInfo.changeEmployeeName, "\u3011\u63A5\u53D7\u540E\uFF0C\u60A8\u7684\u7BA1\u7406\u5458\u8EAB\u4EFD\u53CA\u7BA1\u7406\u5458\u6743\u9650\u5C06\u88AB\u6536\u56DE\u3002"] })), dataInfo.verifyStatus === 1 && (_jsxs("span", { children: ["\u3010", dataInfo.changeEmployeeName, "\u3011\u5DF2\u62D2\u7EDD\u6210\u4E3A\u4F01\u4E1A\u7BA1\u7406\u5458\uFF0C\u62D2\u7EDD\u539F\u56E0\uFF1A", dataInfo.refuseRemark
                                                ? dataInfo.refuseRemark
                                                : dataInfo.description, "\u3002"] })), dataInfo.verifyStatus === 2 && (_jsxs("span", { children: ["\u3010", dataInfo.changeEmployeeName, "\u3011\u5DF2\u6210\u4E3A\u3010", dataInfo.companyName, "\u3011\u7684\u4F01\u4E1A\u7BA1\u7406\u5458\u3002"] })), dataInfo.verifyStatus === 3 && (_jsxs("span", { children: ["\u60A8\u5DF2\u64A4\u9500\u9080\u8BF7\u3010", dataInfo.changeEmployeeName, "\u3011\u6210\u4E3A\u3010", dataInfo.companyName, "\u3011\u7684\u4F01\u4E1A\u7BA1\u7406\u5458\u7684\u7533\u8BF7\u3002"] })), dataInfo.verifyStatus === 4 && (_jsxs("span", { children: ["\u60A8\u9080\u8BF7\u3010", dataInfo.changeEmployeeName, "\u3011\u6210\u4E3A\u3010", dataInfo.companyName, "\u3011\u7684\u4F01\u4E1A\u7BA1\u7406\u5458\u7684\u7533\u8BF7\u5DF2\u8FC7\u671F\u3002"] }))] })] }), showIcon: true }), _jsxs("p", { style: {
                        marginTop: '20px',
                        marginBottom: '30px',
                        fontWeight: 'bolder',
                    }, children: ["\u4F01\u4E1A\u7BA1\u7406\u5458\u3010", dataInfo.employeeName, "\u3011\u9080\u8BF7\u3010", dataInfo.changeEmployeeName, "\u3011\u6210\u4E3A\u3010", dataInfo.companyName, "\u3011\u7684\u7BA1\u7406\u5458\u3002\u672C\u6B21\u9080\u8BF77\u5929\u5185\u6709\u6548\uFF0C\u8BF7\u63D0\u9192\u3010", dataInfo.changeEmployeeName, "\u3011\u4E8E", _jsx("span", { style: { color: 'var( --lj-primary-color )' }, children: dataInfo.createdDatetime &&
                                moment(dataInfo.createdDatetime).format('YYYY-MM-DD') }), ' ', "\u524D\u63A5\u4EFB\u4F01\u4E1A\u7BA1\u7406\u5458"] }), _jsxs("div", { className: styles.stepsWrap, children: [_jsxs("div", { className: styles.steps, children: [_jsx("i", { className: styles.left }), _jsx("div", { className: styles.center, children: _jsxs("div", { className: classNames(styles.staff, 'staff1'), children: [_jsx("span", { children: dataInfo.employeeName }), dataInfo.verifyStatus === 3 && (_jsx("span", { className: "msg", style: { color: '#aaa', fontWeight: 500 }, children: "\u5DF2\u64A4\u9500" }))] }) }), _jsx("div", { className: styles.right, children: _jsxs("div", { className: classNames(styles.info, 'rightInfo'), children: [_jsx("span", { className: "time", children: dataInfo.createdDatetime &&
                                                    moment(dataInfo.createdDatetime).format('YYYY-MM-DD HH:mm:ss') }), _jsx("span", { className: "msg", children: "\u7533\u8BF7\u66F4\u6362\u7BA1\u7406\u5458" })] }) })] }), _jsxs("div", { className: styles.steps, style: { marginTop: '40px' }, children: [_jsx("i", { className: classNames(styles.left, {
                                        grey: [0, 3].includes(dataInfo.verifyStatus),
                                    }) }), _jsx("div", { className: styles.center, children: _jsxs("div", { className: classNames(styles.staff, {
                                            grey: [0, 3].includes(dataInfo.verifyStatus),
                                        }), children: [_jsx("span", { children: dataInfo.changeEmployeeName }), dataInfo.verifyStatus !== 3 && (_jsx("span", { className: "msg", style: {
                                                    fontWeight: 500,
                                                    color: stateMap(dataInfo.verifyStatus)?.color,
                                                }, children: stateMap(dataInfo.verifyStatus)?.text }))] }) }), _jsx("div", { className: styles.right, children: [1, 3, 4].includes(dataInfo.verifyStatus) && (_jsxs("div", { className: classNames(styles.info, 'rightInfo'), children: [_jsx("span", { className: "time", children: dataInfo.modiDatetime &&
                                                    moment(dataInfo.modiDatetime).format('YYYY-MM-DD HH:mm:ss') }), [1, 4].includes(dataInfo.verifyStatus) && (_jsx("span", { className: "msg", children: dataInfo.description }))] })) })] }), _jsx("div", { className: classNames(styles.leftLine, {
                                grey: [0, 3].includes(dataInfo.verifyStatus),
                            }) })] })] }) }));
};
export default SenderDraw;
